import { render, staticRenderFns } from "./RegionEdit.vue?vue&type=template&id=ff6ef03e&scoped=true"
import script from "./RegionEdit.vue?vue&type=script&lang=js"
export * from "./RegionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6ef03e",
  null
  
)

export default component.exports